import React from 'react'
import "./SGCover-style.css"

export const SGCover = props => {
    return (
        <img src={require("../../assets/images/banner.jpeg")} alt="" className="sg-cover"/>
    )
}